import type { McpDiscoveryAuthModelDto } from '@terra/shared-contracts-mcp-servers';
import { discoverMcpOAuthScopes } from './discover-mcp-oauth-scopes';
import { discoverMcpServerOAuthScopes } from './discover-mcp-server-oauth-scopes';

function normalizeDiscoveryUrl(url: string): string {
  return url.trim().replace(/\/+$/, '');
}

export async function resolveMcpOAuthScopeDiscovery({
  discoveryUrl,
  mcpServerId,
  oauthIdentityId,
  persistedDiscoveryUrl,
}: {
  discoveryUrl: string;
  mcpServerId?: string | null;
  oauthIdentityId?: string | null;
  persistedDiscoveryUrl?: string | null;
}): Promise<McpDiscoveryAuthModelDto | null> {
  const urlResult = await discoverMcpOAuthScopes(discoveryUrl);
  if (urlResult?.scopesSupported.length) {
    return urlResult;
  }

  const shouldUseServerPersistedFallback =
    mcpServerId &&
    (!persistedDiscoveryUrl ||
      normalizeDiscoveryUrl(discoveryUrl) ===
        normalizeDiscoveryUrl(persistedDiscoveryUrl));

  if (shouldUseServerPersistedFallback) {
    const serverResult = await discoverMcpServerOAuthScopes({
      serverId: mcpServerId,
      identityId: oauthIdentityId ?? undefined,
    });
    if (serverResult?.scopesSupported.length) {
      return serverResult;
    }
  }

  return urlResult;
}
